import React from "react";
import UserGreenIcon from "../../../Common/svg/usergreenicon";

const TimeLineInfo = ({ status_history ,type }) => {
  let orderStatuses = [
    "pending",
    "confirmed",
    "processing",
    "ready_for_delivery",
    "on_the_way",
    "delivered",

  ];  
if(type ==="package"){
  orderStatuses =[ 
    "ready_for_delivery",
    "on_the_way",
    "delivered",]
}

  function getStatusLabel(status) {
    switch (status) {
      case "pending":
        return "بانتظار المراجعة";
      case "confirmed":
        return "تم تأكيد الطلب";
      case "processing":
        return "جار تجهيز الطلب";
      case "ready_for_delivery":
        return "جاهز للاستلام";
      case "on_the_way":
        return "في طريق التوصيل";
      case "delivered":
        return "تم تسليم الطلب";
      case "cancelled":
        return "إلغاء الطلب";
      default:
        return status;
    }
  }
    const cancelledRecord = status_history.find(
    (s) => s.status.value === "cancelled"
  );

  const isOrderCancelled = !!cancelledRecord;

  let steps = orderStatuses.map((status) => {
    const statusRecord = status_history.find(
      (s) => s.status.value === status
    );
    return {
      status,
      label: getStatusLabel(status),
      time: statusRecord?.created_at,
      completed: !!statusRecord
    };
  });
  if(isOrderCancelled){
     const lastCompletedIndex = steps.findLastIndex(
      (step) => step.completed
    );

    steps = steps.slice(0, lastCompletedIndex + 1);

    steps.push({
      status: "cancelled",
      label: getStatusLabel("cancelled"),
      time: cancelledRecord.created_at,
      completed: true,
    });
  }
  return (
    <div className="col-md-6">
      <div className="card rounded-4 shadow-sm">
        <div className="card-body">
          <div className="d-flex align-items-center gap-2">
            <UserGreenIcon />
            <h5 className="text-smoke font16 font700">
              تفاصيل الجدول الزمني للطلب
            </h5>
          </div>

          <div className="timeline mt-3">
            {steps.map((step, index) => {
              const nextStepCompleted = steps[index + 1]?.completed;

              const isCancelled = step.status === "cancelled";

              return (
                <div className="timeline-row" key={index}>
                  <div
                    className={`
                      timeline-icon 
                      ${index !== steps.length - 1 ? "line" : ""} 
                      ${nextStepCompleted ? "line-done" : ""} 
                      ${isCancelled ? "cancelled" : ""}
                    `}
                  >
                    <div
                      className={`
                        dot 
                        ${step.completed ? "done" : ""} 
                        ${isCancelled ? "cancelled" : ""}
                      `}
                    ></div>
                  </div>

                  <div className="timeline-content">
                    <div className={`title text-gray ${isCancelled ? "text-danger" : ""}`}>
                      {step.label}
                    </div>
                    <div className={`time text-smoke ${isCancelled ? "text-danger" : ""}`}>
                      {step.time}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeLineInfo;
